import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const Compliance = {
  Helmet: lazyNamed(() => import('./components/Helmet.tsx'), 'Helmet'),
  Layout: lazyNamed(() => import('./components/Layout.tsx'), 'Layout'),
  ListPriceChanges: lazyNamed(() => import('./pages/ListPriceChanges/index.tsx'), 'ListPriceChanges'),
  PositionFinancials: lazyNamed(() => import('./pages/PositionFinancials/index.tsx'), 'PositionFinancials'),
  AccountFinancials: lazyNamed(() => import('./pages/AccountFinancials/index.tsx'), 'AccountFinancials'),
  CreditNotes: lazyNamed(() => import('./pages/CreditNotes/index.tsx'), 'CreditNotes'),
};
